import uuid from 'uuid';
import { SET_X_TRACE_ID } from './constants';

/**
 * Creates an action that stores a new x-trace-id in Redux state.
 *
 * @returns {Object} A synchronous Redux action.
 */
export function setXTraceId() {
  return {
    type: SET_X_TRACE_ID,
    xTraceId: uuid.v4(),
  };
}
